import Messaging from "../components/Messaging/Messaging";
export default function MessagingPage() {
  return <Messaging />;
}
